import { useEffect, useState } from "react";
import { ChevronDown } from "lucide-react";
import { api } from "@/lib/api";

const dot = (f) => (f.ok ? "bg-emerald-400" : f.checked_at ? "bg-atlas-red" : "bg-white/30");

const FeedRow = ({ f }) => (
  <div className="flex flex-wrap items-center gap-x-2 py-1 border-b border-white/5 text-[11px] font-mono" data-testid={`coverage-feed-${f.url}`}>
    <span className={`w-1.5 h-1.5 rounded-full shrink-0 ${dot(f)}`} />
    <span className="text-white/90 w-28 sm:w-44 shrink-0 truncate" title={f.country}>{f.country}</span>
    <span className="text-atlas-secondary flex-1 min-w-[6rem] truncate" title={`${f.agency} · ${f.url}`}>{f.agency}</span>
    <span className="text-atlas-secondary/85 whitespace-nowrap ml-auto">{f.ok ? `${f.confirming ?? 0} live · ${f.logged_total} logged` : f.checked_at ? "unreachable" : "not checked yet"}</span>
  </div>
);

export const AgencyCoverage = () => {
  const [d, setD] = useState(null);
  const [open, setOpen] = useState(false);
  useEffect(() => { api.nationalCoverage().then(setD).catch(() => setD(null)); }, []);
  if (!d) return null;
  const ok = d.feeds.filter((f) => f.ok).length;
  return (
    <div className="border border-white/10 bg-atlas-surface/50" data-testid="agency-coverage">
      <button onClick={() => setOpen(!open)} className="w-full flex items-center justify-between px-3 py-2.5 text-left hover:bg-white/[0.03] transition-colors" data-testid="agency-coverage-toggle">
        <span className="text-[10px] font-mono uppercase tracking-widest text-atlas-secondary">
          National agency coverage · {d.feeds.length} official feeds ({ok} answering) · {d.covered_countries} of {d.dropdown_countries} countries covered
        </span>
        <ChevronDown className={`w-4 h-4 text-atlas-secondary transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="px-3 pb-3" data-testid="agency-coverage-list">
          {d.feeds.map((f) => <FeedRow key={f.url} f={f} />)}
          <p className="text-[10px] font-mono text-atlas-secondary/85 mt-3" data-testid="agency-coverage-elsewhere">
            Covered through MeteoAlarm or the dedicated feeds above: {d.covered_elsewhere.join(", ")}.
          </p>
          <p className="text-[10px] font-mono text-atlas-secondary/85 mt-2" data-testid="agency-coverage-none">
            No public machine-readable warning feed found ({d.no_feed.length}): {d.no_feed.join(", ")}.
          </p>
        </div>
      )}
    </div>
  );
};
